<template>
  <div>
    <div class="ft-alert-success" v-if="successMsg"><i class="fas fa-check-circle"></i> {{ successMsg }}</div>

    <div class="ft-card">
      <div class="ft-card-header-row">
        <h3 class="ft-card-title"><i class="fas fa-newspaper"></i> Blog Posts</h3>
        <router-link to="/admin/blog/create" class="ft-btn"><i class="fas fa-plus"></i> New Post</router-link>
      </div>

      <form class="ft-filter-form" @submit.prevent="load(1)">
        <div class="ft-field">
          <label>Status</label>
          <select v-model="filters.status">
            <option value="">All</option>
            <option value="published">Published</option>
            <option value="draft">Draft</option>
          </select>
        </div>
        <div class="ft-field" style="min-width:220px;">
          <label>Search Title</label>
          <input type="text" v-model="filters.search">
        </div>
        <div class="ft-field">
          <button type="submit" class="ft-btn"><i class="fas fa-filter"></i> Filter</button>
        </div>
        <div class="ft-field">
          <button type="button" class="ft-btn ft-btn-outline" @click="resetFilters"><i class="fas fa-undo"></i> Reset</button>
        </div>
      </form>

      <div class="ft-blog-grid" v-if="posts.length">
        <div class="ft-blog-post-card" v-for="post in posts" :key="post.id">
          <img :src="storageUrl + 'banner_content/' + post.banner" alt="" class="ft-blog-post-thumb">
          <div class="ft-blog-post-body">
            <span class="ft-badge" :class="'ft-badge-'+post.status" style="align-self:flex-start;">{{ post.status }}</span>
            <div class="ft-blog-post-title">{{ post.title }}</div>
            <div class="ft-blog-post-meta">
              <span><i class="far fa-user"></i> {{ post.created_by || '-' }}</span>
              <span>{{ formatDate(post.created_at) }}</span>
            </div>
            <div class="ft-blog-post-actions">
              <router-link :to="'/admin/blog/'+post.id+'/edit'" class="ft-btn ft-btn-sm ft-btn-outline"><i class="fas fa-pencil-alt"></i> Edit</router-link>
              <button class="ft-btn ft-btn-sm ft-btn-danger" @click="remove(post.id)"><i class="fas fa-trash"></i> Delete</button>
            </div>
          </div>
        </div>
      </div>
      <div class="ft-empty-state" v-else><i class="fas fa-newspaper"></i> No blog posts yet.</div>

      <div class="ft-pagination">
        <button :disabled="page <= 1" @click="load(page - 1)"><i class="fas fa-chevron-left"></i></button>
        <span class="ft-page-info">Page {{ page }} of {{ lastPage }}</span>
        <button :disabled="page >= lastPage" @click="load(page + 1)"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import blog from '@/services/adminBlog.service';
import Api from '@/helpers/adminApi';
import config from '@/configs/config';
import moment from 'moment';

export default {
  name: 'AdminBlog',
  data() {
    return {
      posts: [],
      page: 1,
      lastPage: 1,
      filters: { status: '', search: '' },
      storageUrl: config.blogStorageUrl,
      successMsg: '',
    };
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page) {
      this.page = page;
      let context = this;
      Api(context, blog.index({ ...this.filters, page })).onSuccess(function (response) {
        context.posts = response.data.data.data;
        context.lastPage = response.data.data.last_page;
      }).call();
    },
    resetFilters() {
      this.filters = { status: '', search: '' };
      this.load(1);
    },
    remove(id) {
      if (!confirm('Delete this post?')) return;
      let context = this;
      Api(context, blog.delete(id)).onSuccess(function () {
        context.successMsg = 'Blog post deleted.';
        context.load(context.page);
        setTimeout(() => { context.successMsg = ''; }, 3000);
      }).call();
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
  },
};
</script>
